// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3NJyI","title":"ClientInsurance_title__76oD_","itemText":"ClientInsurance_itemText__2bAMz"};